import { DocumentNode, gql } from '@apollo/client'

export const REQUEST_DAYCARE: DocumentNode = gql`
    mutation RequestDaycare(
        $daycare_name: String!
        $daycare_address: String!
        $daycare_email: String
        $daycare_telephone: String
    ) {
        createDaycareRequest(
            daycare_name: $daycare_name
            daycare_address: $daycare_address
            daycare_email: $daycare_email
            daycare_telephone: $daycare_telephone
        )
    }
`
